
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages/[...slug]",
      function () {
        return require("private-next-pages/packages/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages/[...slug]"])
      });
    }
  